var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-welcome-modal-dialog',{attrs:{"editID":_vm.editID,"showDialog":_vm.showDialog,"onGetData":_vm.getModalData,"onClose":function () {_vm.editID = null}}}),_c('custom-table',{attrs:{"icon":"mdi-sticker-alert","title":"settings.welcomeModal.title","headers":[{
          text: _vm.$t('settings.welcomeModal.name'),
          align: 'left',
          sortable: false,
          value: 'ident',
        },
        {
          text: _vm.$t('settings.welcomeModal.preview'),
          align: 'center',
          sortable: false,
          value: 'preview',
        },
        {
          text: _vm.$t('settings.welcomeModal.hide'),
          align: 'center',
          sortable: false,
          value: 'hide',
        },
        {
          text: _vm.$t('settings.welcomeModal.remember'),
          align: 'center',
          sortable: false,
          value: 'remember',
        },
        {
          text: '',
          sortable: false,
          value: 'log',
        } ],"data":_vm.data,"count":_vm.count,"loading":_vm.loading,"onAdd":_vm.handleAdd,"color":_vm.enterpriseColor,"isWelcomeModal":true,"itemsPerPage":100000}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }